<template>

    <hp5-call-to-action
        :href="href"
        size="md"
        :target="target"
        :text="text"
        type="secondary"
        v-if="showCallToAction"
    />
    
    </template>
    
    <script setup>
    
        const props = defineProps({
            clinic: Object
        })
    
        // if the clinic has no url or phone number, don't show the button
        const showCallToAction = props.clinic.locationUrl || props.clinic.phone
        // show phone number as the text if virtual visit is not available
        const text = props.clinic.locationUrl ? "Start a virtual visit" : props.clinic.phone
        // use the location url if provided; otherwise, use a tel link
        const href = props.clinic.locationUrl ? props.clinic.locationUrl : `tel:${props.clinic.phone}`
        // only open up a new window if there is a location url; otherwise, tel link can act on current window
        const target = props.clinic.locationUrl ? '_blank' : '_self'
    
    </script>